<template>
  <div class="aside-menu flex-column-fluid" style="overflow-y: auto; max-height: 80vh; overflow-x: hidden !important;">
    <div id="kt_aside_menu_wrapper"
         class="hover-scroll-overlay-y"
         data-kt-scroll="true"
         data-kt-scroll-activate="{default: false, lg: true}"
         data-kt-scroll-dependencies="#kt_aside_logo, #kt_aside_footer"
         data-kt-scroll-height="auto"
         data-kt-scroll-offset="0"
         data-kt-scroll-wrappers="#kt_aside_menu">

      <div id="kt_aside_menu"
           class="menu menu-column menu-sub-indention fw-semibold fs-6"
           data-kt-menu="true" data-kt-menu-expand="false">
          <template v-for="(section, index) in menu" :key="index">
          <div v-if="section.sectionTitle && $canAccess(section.module) && canMenu(section.permission, section.teamScope)" class="menu-item pt-2">
            <div class="menu-content">
              <span class="menu-heading fw-bold text-uppercase fs-7 text-gray-700"> {{ section.sectionTitle }} </span>
            </div>
          </div>

          <template v-for="(menuItems, index) in section.children" :key="index">
            <div v-if="menuItems.children.length && canMenu(menuItems.permission, menuItems.teamScope)  && $canAccess(menuItems.module) " :id="menuItems?.id" class="menu-accordion menu-item" :class="{ 'show': activateUrl(menuItems.group) }" data-kt-menu-trigger="click">
              <span class="menu-link">
                <span class="menu-icon position-relative mr-3">
                  <i class="fs-2" :class="menuItems.icon"></i>
                  <span v-if="menuItems.nbr" :key="menuItems.id+'-'+menuItems.title+'-'+menuItems.nbr" class="showBullet bullet bullet-dot bg-danger h-6px w-6px position-absolute translate-middle top-0 start-50 animation-blink"></span>
                </span>
                <span class="menu-title">{{ menuItems.title }}</span><span class="menu-arrow"></span>
              </span>
              <div class="menu-sub menu-sub-accordion" :class="{ 'show': activateUrl(menuItems.group) }">
                <div v-for="(items, index) in menuItems.children" :key="index" class="menu-item" >
                  <router-link class="menu-link"
                               :class="{ 'active': activateUrl(items.group) }"
                              :to="{name: items.route}"
                              v-if="canMenu(items.permission, items.teamScope) && $canAccess(items.module)"
                              v-license="items?.license"
                  >
                            <span class="menu-bullet">
                              <span class="bullet bullet-dot"></span>
                            </span>
                    <span class="menu-title">{{ items.title }} </span>
                  </router-link>
                </div>

              </div>
            </div>

            <div v-else-if="canMenu(menuItems.permission, menuItems.teamScope) && $canAccess(menuItems.module)"
                 class="menu-item "
                 :class="menuItems.customClass">
              <router-link  class="menu-link" :class="{ 'active': activateUrl( menuItems.group) }" :to="{name: menuItems.route}" v-license="menuItems?.license">
                <div :id="menuItems?.id" class="menu-icon position-relative mr-3">
                  <i class="fs-2" :class="menuItems.icon"></i>
                  <span v-if="menuItems.nbr" :key="menuItems.id+'-'+menuItems.title+'-'+menuItems.nbr" class="showBullet bullet bullet-dot bg-danger h-6px w-6px position-absolute translate-middle top-0 start-50 animation-blink"></span>
                </div>
                <span class="menu-title d-flex justify-content-between">{{ menuItems.title }} <span v-if="menuItems.nbr" :key="menuItems.id+'-'+menuItems.title+'-'+menuItems.nbr"  class="ms-2 badge badge-circle badge-danger">{{ menuItems.nbr }}</span></span>
              </router-link>
            </div>
          </template>


        </template>
      </div>
    </div>
  </div>

  <div class="aside-footer flex-column-auto pt-5 pb-7 px-5" id="kt_aside_footer">
    <div style="padding: 0px!important;" class="btn btn-custom btn-light-primary btn-active-light-primary w-100 mb-2" @click="startTour">
      <span class="btn-label py-3">{{$t('guide')}}</span>
      <span class="btn-icon" style="padding: 0px!important;">{{ $t('guide') }}</span>
    </div>

    <div style="padding: 0px!important;" class="btn btn-custom btn-light-primary btn-active-light-primary w-100" >
      <span class="btn-label py-3">Version {{ appVersion }}</span>
      <span class="btn-icon" style="padding: 0px!important;">v{{ appVersion }}</span>
    </div>
  </div>
</template>

<script>
import { appVersion } from "@/mixins/Helpers";
import abilities from "@/composables/abilities";
import moduleAbilities from "@/composables/moduleAbilities";
import i18n from "@/plugins/i18n";
import shopMenu from '@/Modules/Shop/menu'
import {licenseModules} from "@/composables/useLicense";
import { useTour } from "@/composables/useTour.js";

const TEAM_SPECIFIC_SET = new Set(abilities.TEAM_SPECIFIC || [])

const SHOP_TEAM_HINTS = ['shop']
const STORE_TEAM_HINTS = ['store', 'warehouse', 'magasin']

const SHOP_PERMISSION_HINTS = [
  'shop_',
  'entry_shop',
  'transfer_shop',
  'shop_sale',
  'shop_user',
  'shop_cash',
  'shop_store',
  'shop_product',
  'sales_session',
  'can_sale_product',
]

const STORE_PERMISSION_HINTS = [
  'magasin',
  'store_',
  'user_magasin',
  'product_magasin',
]

const normalizeTeamType = (team) => `${team?.team_type || team?.group_type || ''}`.toLowerCase()
const matchesAny = (value, hints) => hints.some((hint) => value.includes(hint))
const isShopTeam = (team) => matchesAny(normalizeTeamType(team), SHOP_TEAM_HINTS)
const isStoreTeam = (team) => matchesAny(normalizeTeamType(team), STORE_TEAM_HINTS)
const isShopPermission = (permission) => matchesAny(`${permission || ''}`.toLowerCase(), SHOP_PERMISSION_HINTS)
const isStorePermission = (permission) => matchesAny(`${permission || ''}`.toLowerCase(), STORE_PERMISSION_HINTS)

const SHOP_TEAM_ROUTES = new Set([
  'shop-view',
  'shop-products',
  'entering-storage',
  'stock-transfer',
  'stock-transfer-create',
  'agents',
  'box',
  'sales',
  'entrepot-config',
  'shop-users',
  'shop-boxes',
  'shop-sales',
  'shop-store-config',
  'shop-supplies',
  'shop-supply-detail'
])

const STORE_TEAM_ROUTES = new Set([
  'shop-warehouse-view',
  'shop-store-products',
  'shop-store-users',
  'shop-store-entries',
  'shop-store-entry-create',
  'shop-store-entry-transfer',
  'shop-store-supplies'
])
 
export default {
  data() {
    return {
      contact: ['contacts-path','contact-view-path', 'contact-fiche', 'contact-addresses'],
      modules: ['modules'],
      settings: ['settings-new', 'settings-taxes', 'settings', 'settings-users', 'settings-rights-view', 'settings-rights',
        'settings-departments','settings-system-mail', 'settings-department-users',
      'settings-leaves', 'settings-leave-create', 'settings-leave-update', ],
      stats: ["shop-statistic"],
      dashboard: ["shop-dashboard"]
    }
  },
  computed: {
    menu() {
      return [
        {
          sectionTitle: '',
          module : '',
          children: [
            {
                title: i18n.global.t('menu.shop.dashboard'),
                icon: 'fas fa-home icon-right2',
                route: 'shop-dashboard',
                group: this.dashboard,
                id: 'step-shop-dashboard',
                children: [],
                module: moduleAbilities.DASHBOARD,
            },
            {
              title: i18n.global.t('menu.contacts'),
              module : moduleAbilities.CONTACT,
              icon: 'fas fa-users',
              route: 'contacts-path',
              group: this.contact,
              id: 'contacts-path',
              permission: [abilities.VIEW_CONTACT],
              teamScope: 'global',
              children: [],
              query: {viewType: 'card'},
              license:  licenseModules.CONTACT_WEB
            },
          ]
        },
        {
          sectionTitle: i18n.global.t('menu.catalog'),
          module: '',
          children: [
            {
              title: i18n.global.t('menu.products'),
              module: '',
              icon: 'fas fa-box-open',
              route: 'items',
              group: ['items'],
              id: 'step-catalog-items',
              permission: [abilities.VIEW_PRODUCT],
              children: [],
              license: licenseModules.PRODUCT_WEB,
            },
            {
              title: i18n.global.t('menu.bundles'),
              module: '',
              icon: 'fas fa-boxes',
              route: 'bundles',
              group: ['bundles'],
              id: 'step-catalog-bundles',
              permission: [abilities.VIEW_BUNDLE],
              children: [],
              license: licenseModules.BUNDLE_WEB,
            },
          ]
        },
        ...shopMenu.menus.value,
        {
          sectionTitle: i18n.global.t('menu.settings'),
          module: '',
          permission: [abilities.VIEW_SETTINGS],
          teamScope: 'global',
          children: [
            {
              title: i18n.global.t('menu.settings'),
              icon: 'fas fa-cog icon-right2',
              route: 'settings',
              group: this.settings,
              id: 'step-setting',
              teamScope: 'global',
              children: [],
              query: {},
              customClass: 'menu-settings-bottom',
            }
          ]
        },
      ]
    },
    appVersion() {
      return appVersion.value
    },
    permissions() {
      return this.$store.getters['permission/permissions'] || []
    },
    permissionsByTeam() {
      return this.$store.getters['permission/permissionsByTeam'] || []
    },
    globalPermissions() {
      const globalTeam = (this.permissionsByTeam || []).find(
        (team) => team?.team_id === 'global_team' || team?.team_type === 'global'
      )

      if (globalTeam?.permissions?.length) {
        return globalTeam.permissions
      }

      return Array.isArray(this.permissions) ? this.permissions : []
    },
    scopedTeamPermissions() {
      const any = new Set()
      const shop = new Set()
      const store = new Set()

      ;(this.permissionsByTeam || []).forEach((team) => {
        const perms = Array.isArray(team?.permissions) ? team.permissions : []
        const shopTeam = isShopTeam(team)
        const storeTeam = isStoreTeam(team)

        perms.forEach((perm) => {
          if (!perm) {
            return
          }

          any.add(perm)
          if (shopTeam) {
            shop.add(perm)
          }
          if (storeTeam) {
            store.add(perm)
          }
        })
      })

      return {
        any: [...any],
        shop: [...shop],
        store: [...store],
      }
    },
    permissionsByScope() {
      const merge = (base = [], extra = []) => [...new Set([...(base || []), ...(extra || [])])]
      const global = this.globalPermissions
      const { any, shop, store } = this.scopedTeamPermissions

      return {
        global: merge([], global),
        any: merge(global, any),
        shop: merge(global, shop),
        store: merge(global, store),
      }
    },
  },

  methods: {
    activateUrl(group) {
      return group.includes(this.$route.name)
    },
    resolveScope(scope, permission) {
      if (scope) {
        return scope
      }
      if (TEAM_SPECIFIC_SET.has(permission)) {
        return 'any'
      }
      return 'global'
    },
    getPermissionsForScope(scope, permission) {
      const resolvedScope = this.resolveScope(scope, permission)
      return this.permissionsByScope[resolvedScope] || this.permissionsByScope.global || []
    },
    canMenu(permissionName = null, scope = null) {
      if (!permissionName || (Array.isArray(permissionName) && permissionName.length === 0)) {
        return true
      }

      const checkPermission = (perm) => {
        if (!perm) {
          return true
        }
        const permissionList = this.getPermissionsForScope(scope, perm)
        return Array.isArray(permissionList) && permissionList.includes(perm)
      }

      if (Array.isArray(permissionName)) {
        for (const perm of permissionName) {
          if (checkPermission(perm)) {
            return true
          }
        }
        return false
      }

      return checkPermission(permissionName)
    },
    resolveActiveTeam(route) {
      const routeName = route?.name
      const id = route?.params?.id

      if (routeName && SHOP_TEAM_ROUTES.has(routeName)) {
        return id || null
      }
      if (routeName && STORE_TEAM_ROUTES.has(routeName)) {
        return id || null
      }

      return null
    },
    openCreateModal(){

    },
    startTour() {
      const { startTour } = useTour();
      startTour();
    },
  },

  watch: {
    $route: {
      immediate: true,
      handler(to) {
        const teamId = this.resolveActiveTeam(to)
        this.$store.commit('permission/SET_ACTIVE_TEAM', teamId || null)
      }
    }
  },
  beforeUnmount() {
    this.$store.commit('permission/SET_ACTIVE_TEAM', null)
  }
}
</script>
<style scoped>
.aside.aside-dark .pos-btn-custom {
  color: #b5b5c3;
  background-color: rgba(63, 66, 84, .35);
}
.aside .pos-btn-custom {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 0;
  padding-right: 0;
}

[data-kt-aside-minimize="on"] .aside .menu-icon .showBullet {
  display: block !important;
}

[data-kt-aside-minimize="on"] .aside:hover .menu-icon .showBullet {
  display: none !important;
}

.showBullet {
  display: none !important;
}

.menu-settings-bottom {
  margin-top: 2rem;
}
</style>
